import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { ROLE_MENU_ONLY } from '@/components/layout/data/sidebar-data'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    const { accessToken, role } = useAuthStore.getState().auth
    if (!accessToken) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }
    // roles with a limited menu (e.g. Teknisi Lapangan) stay on their pages;
    // the dashboard and other pages send them to their home page
    const only = role?.name ? ROLE_MENU_ONLY[role.name] : undefined
    // (their own profile stays reachable from the account menu)
    if (
      only &&
      ![...only, '/profile'].some((p) => location.pathname.startsWith(p))
    )
      throw redirect({ to: only[0] })
  },
  component: AuthenticatedLayout,
})
